import { Link, useLocation, useNavigate } from "react-router-dom";
import { Terminal, Database, Sparkles, Shield, LogOut, Grid3x3 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NavItem = ({ to, icon: Icon, label, testid, active }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`flex items-center gap-2 px-3 py-2 rounded-md font-mono text-sm transition-all ${
      active ? "text-[#00ff66] bg-[#00ff66]/10" : "text-slate-400 hover:text-slate-100 hover:bg-white/5"
    }`}
  >
    <Icon size={16} />
    <span className="hidden md:inline">{label}</span>
  </Link>
);

export const Navbar = () => {
  const { pathname } = useLocation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 glass border-b border-[#00ff66]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-button" className="flex items-center gap-2.5 group">
          <div className="w-9 h-9 rounded-md bg-[#00ff66]/10 border border-[#00ff66]/40 flex items-center justify-center glow-pulse">
            <Terminal size={18} className="text-[#00ff66]" />
          </div>
          <div className="leading-tight">
            <div className="font-mono font-extrabold text-base tracking-tight">
              exploit<span className="text-[#00ff66]">vault</span>
            </div>
            <div className="font-mono text-[9px] text-slate-500 tracking-[0.25em] uppercase">breach // defend</div>
          </div>
        </Link>

        <nav className="flex items-center gap-1">
          <NavItem to="/database" icon={Database} label="Database" testid="nav-link-database" active={pathname.startsWith("/database")} />
          <NavItem to="/categories" icon={Grid3x3} label="Categories" testid="nav-link-categories" active={pathname.startsWith("/categories")} />
          <NavItem to="/ai-generator" icon={Sparkles} label="AI Gen" testid="nav-link-ai-generator" active={pathname.startsWith("/ai-generator")} />
          {user ? (
            <>
              <NavItem to="/admin" icon={Shield} label="Admin" testid="nav-link-admin" active={pathname.startsWith("/admin")} />
              <button
                data-testid="nav-logout-button"
                onClick={() => { logout(); navigate("/"); }}
                className="flex items-center gap-2 px-3 py-2 rounded-md font-mono text-sm text-slate-400 hover:text-[#ef4444] transition-colors"
              >
                <LogOut size={16} />
              </button>
            </>
          ) : (
            <NavItem to="/admin/login" icon={Shield} label="Admin" testid="nav-link-admin" active={pathname.startsWith("/admin")} />
          )}
        </nav>
      </div>
    </header>
  );
};
